// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._48G8HlsXAaq0PY30sVJTLQ\\=\\={margin-bottom:1rem}", "",{"version":3,"sources":["webpack://./src/blocks/bundlePdp/BundleItem/BundleItem.module.scss"],"names":[],"mappings":"AAGA,6BACE,kBAAA","sourcesContent":["\n                @import '~@purple/style-library/sass/base/base';\n              \n.bundle-item-container {\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bundle-item-container": "_48G8HlsXAaq0PY30sVJTLQ=="
};
export default ___CSS_LOADER_EXPORT___;
